<div *ngIf="showPropertyList" class="dialog" [ngStyle]="{'min-height': '100px'}">
    <mat-toolbar class="tool1">
        <div></div>
        <span id="title">Select Existing Property</span>
        <a id="addP" *ngIf="!confirmProperty" (click)="confirmdialog()">
            <mat-icon id="size" svgIcon="plus"></mat-icon>
        </a>
    </mat-toolbar>

    <div *ngIf="loader2" class="hfix">
        <ngx-loading [show]="loader2" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading>
    </div>
    <div *ngIf="confirmProperty">
        <div class="notifiText">Do you want to create property in existing address.</div>
        <div class="notifi">
          <button class="cancelbutton mat-button ml-1" (click)="cancleCreateProperty()" [disabled]="loader2">Cancel</button>
          <button class="applybutton mat-button ml-1" (click)="createProperty()" [disabled]="loader2">Create Property</button>

        </div>
    </div>
    <div *ngIf="!confirmProperty">
      <div *ngIf="permission">
        <div class="notifiText" *ngIf="!loader2">This property is assigned to another user, you can notify the admin to
            update this property.</div>
        <div class="notifi">
          <button class="cancelbutton mat-button ml-1" (click)="cancelNotifi()" [disabled]="loader2">Cancel</button>
          <button class="applybutton mat-button ml-1" (click)="sendNotification()" [disabled]="loader2">Send</button>
        </div>
    </div>
    <div *ngIf="!permission">
        <div class="w-100 subtitle2">
            <span>No of Existing Buildings: </span>{{existingBuildings}}
        </div>
        <mat-tab-group>
            <mat-tab label="Estater ({{countProperty('estater')}})">
                <div class="list-container-p">
                    <div class="fixHeight">
                            <ngx-loading [show]="add_loader" [config]="{backdropBackgroundColour: '#00000021'}"></ngx-loading>
                        <ng-container *ngFor="let data of pData">
                            <div *ngIf="data.property_uid" class="data-container" (click)="selectedProp(data)">
                                <div class="w-100 content1" [class.content2]="!checkMyProp(data)">
                                    <div class="details">
                                        <span>
                                            <strong>ID: </strong>
                                            <strong>{{data.property_uid}}</strong>
                                            <strong *ngIf="data.property_name"> | {{data.property_name}}</strong>
                                        </span>
                                        <button matTooltip="Self assign" (click)="self_assign($event, data)" class="self-assign" *ngIf="checkUnallowcated(data) && assignment_detail?.type == 'self_assign'">
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="20" height="20" x="0" y="0" viewBox="0 0 512 511" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path xmlns="http://www.w3.org/2000/svg" d="m322.535156 81.457031 28.269532-28.269531 49.972656 49.972656 82.953125-82.957031 28.269531 28.269531-111.222656 111.222656zm158.847656 54.171875c19.8125 36.785156 30.332032 78.121094 30.332032 121.078125 0 68.34375-26.613282 132.59375-74.9375 180.921875-48.324219 48.324219-112.578125 74.589844-180.917969 74.589844-68.34375 0-132.59375-26.265625-180.921875-74.589844-48.324219-48.328125-74.9375-112.578125-74.9375-180.921875 0-68.339843 26.613281-132.59375 74.9375-180.917969 48.328125-48.324218 112.578125-75.289062 180.921875-75.289062 27.058594 0 53.472656 4.539062 78.515625 12.578125l-32.664062 32.667969c-14.785157-3.210938-30.121094-4.917969-45.851563-4.917969-119.039063 0-215.882813 96.84375-215.882813 215.878906 0 54.457031 20.28125 104.265625 53.667969 142.285157 11.617188-51.980469 47.640625-94.84375 95.375-115.894532-19.929687-18.171875-32.457031-44.332031-32.457031-73.363281 0-54.75 44.542969-99.296875 99.296875-99.296875 54.75 0 99.292969 44.542969 99.292969 99.296875 0 29.03125-12.523438 55.191406-32.453125 73.363281 47.730469 21.050782 83.757812 63.914063 95.371093 115.894532 33.390626-38.023438 53.667969-87.828126 53.667969-142.285157 0-32.570312-7.265625-63.476562-20.238281-91.195312zm-225.523437 133.421875c32.707031 0 59.316406-26.609375 59.316406-59.316406 0-32.710937-26.609375-59.320313-59.316406-59.320313-32.710937 0-59.320313 26.609376-59.320313 59.320313 0 32.707031 26.609376 59.316406 59.320313 59.316406zm0 203.539063c47.070313 0 90.664063-15.15625 126.179687-40.828125-1.859374-67.992188-57.746093-122.734375-126.179687-122.734375s-124.324219 54.742187-126.179687 122.734375c35.515624 25.671875 79.105468 40.828125 126.179687 40.828125zm0 0" fill="#000000" data-original="#000000" class=""></path></g></svg>
                                        </button>
                                        <span *ngIf="data.status == 5" title="Approved Property" class="appr-prop-dot"></span>
                                    </div>
                                    <div id="pName">
                                        <span class="clampx">{{data.address}}</span>
                                    </div>
                                    <div class="prodetail">
                                        <div>
                                            <strong>No Of Floor: </strong>
                                            <span>{{data.no_of_floors}}</span>
                                        </div>
                                        <div>
                                            <strong>No Of Unit: </strong>
                                            <span>{{data.no_of_units}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="GIS ({{countProperty('gis')}})">
                <div class="list-container-p">
                    <div class="fixHeight">
                        <ng-container *ngFor="let data of gData">
                            <div *ngIf="!data.property_uid" class="data-container" (click)="selectedProp(data, true)">
                                <div class="gisdata">
                                    <div class="details">
                                        <div>
                                            <strong>GIS-ID: </strong>
                                            <strong>{{data.building_uid}}</strong>
                                        </div>
                                        <div>
                                            {{data.building_name}}
                                        </div>
                                    </div>
                                    <div id="pName">
                                        <span class="clampx">{{data.address}}</span>
                                    </div>
                                    <div class="prodetail">
                                        <div>
                                            <strong>No Of Floor: </strong>
                                            <span>{{data.no_of_floors}}</span>
                                        </div>
                                        <div>
                                            <strong>No Of Unit: </strong>
                                            <span>{{data.no_of_units}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    </div>

</div>
<div *ngIf="!showPropertyList" class="dialog">
    <div>
        <mat-toolbar class="tool"><span>Confirmation</span></mat-toolbar>
    </div>
    <div class="message">
        <span>Do you want to Import this property?</span>
    </div>
    <div class="b-middle">
        <button (click)="createProperty()" class="deletebutton" mat-button>Import</button>
        <button (click)="cancel()" class="fix" mat-button>Cancel</button>
    </div>
</div>
